import React from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, CardText, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import './Home.css';
import logo from '../assets/images/logo.png';
import WhatsAppButton from '../components/WhatsAppButton';
import ServiceIcon from '../components/ServiceIcon';
import matjarpos from '../assets/images/matjarpos.png';
import handidpph from '../assets/images/matjarpos.png';
import agritrack from '../assets/images/matjarpos.png';

const Home = () => {

    const phoneNumber = "+212660707129"; // Replace with your number


    const scrollToServices = () => {
        const servicesSection = document.getElementById('services-section');
        servicesSection.scrollIntoView({ behavior: 'smooth' });
    };

    const services = [
        {
            title: "Infrastructures Réseau Performantes",
            description: "Nos solutions réseau professionnelles comprennent:",
            details: [
                "Installation et configuration de réseaux LAN/WAN",
                "Solutions de sécurité réseau avancées",
                "Maintenance préventive et support 24/7",
                "Solutions VPN et accès distant sécurisé"
            ]
        },
        {
            title: "Solutions Digitales Innovantes",
            description: "Nous développons des solutions numériques complètes:",
            details: [
                "Applications web responsive et performantes",
                "Applications mobiles iOS et Android",
                "Sites e-commerce personnalisés",
                "Intégration de systèmes et APIs"
            ]
        },
        {
            title: "Conseils & Expertise IT",
            description: "Notre équipe d'experts vous accompagne dans:",
            details: [
                "L'audit de votre infrastructure IT",
                "La planification stratégique digitale",
                "L'optimisation des coûts IT",
                "La conformité et la sécurité des données"
            ]
        }
    ];

    const projects = [
        {
            title: "MatjarPOS",
            description: "Solution complète de gestion pour points de vente incluant la gestion des ventes, stocks, factures, clients et fournisseurs.",
            image: matjarpos,
            link: "https://matjarepos.com",
            //technologies: ["React", "Node.js", "MongoDB", "Express"],
            features: [
                "Gestion des ventes",
                "Gestion des stocks",
                "Facturation",
                "Gestion clients/fournisseurs"
            ]
        },
        {
            title: "HANDI-DPPH",
            description: "Plateforme de recrutement dédiée aux personnes en situation de handicap en Côte d'Ivoire.",
            image: handidpph,
            link: "https://handi-dpph.org",
            //technologies: ["React", "PHP", "MySQL"],
            features: [
                "Portail de recrutement",
                "Gestion des candidatures",
                "Profils entreprises"
            ]
        },
        {
            title: "AgriTracking",
            description: "Solution de suivi et gestion pour le secteur agricole.",
            image: agritrack,
            link: "https://admin.wodisgroup.com",
            //technologies: ["React", "Node.js", "PostgreSQL"],
            features: [
                "Suivi des cultures",
                "Gestion des parcelles",
                "Analyses et rapports"
            ]
        }
    ];

    return (
        <>
            <div className="hero-section text-white">
                <div className="hero-overlay">
                    <Container>
                        <div className="text-center py-5">
                            <img
                                src={logo}
                                alt="IderaCloud Logo"
                                className="logo-img mb-4"
                            />
                            <h1 className="display-4">Bienvenue chez IDERACLOUD</h1>
                            <p className="lead">
                                Votre partenaire technologique pour des solutions innovantes et performantes
                            </p>
                            <Button 
                                color="light" 
                                size="lg" 
                                className="mt-4 custom-btn"
                                onClick={scrollToServices}
                            >
                                Découvrir nos services
                            </Button>
                        </div>
                    </Container>
                </div>
            </div>

            <Container id="services-section" className="services-section py-5">
                <h2 className="text-center mb-5">Nos Services</h2>
                <Row>
                    {services.map((service, index) => (
                        <Col md={4} className="mb-4" key={index}>
                            <Card className="h-100 service-card">
                                <div className="service-icon">
                                    <ServiceIcon index={index} />
                                </div>
                                <CardBody>
                                    <CardTitle tag="h3" className="mb-3">
                                        {service.title}
                                    </CardTitle>
                                    <CardText>
                                        <p className="fw-bold">{service.description}</p>
                                        <ul className="service-list">
                                            {service.details.map((detail, idx) => (
                                                <li key={idx}>
                                                    <i className="bi bi-check-circle-fill me-2"></i>
                                                    {detail}
                                                </li>
                                            ))}
                                        </ul>
                                    </CardText>
                                    <Button className="custom-btn mt-auto">
                                        En savoir plus
                                    </Button>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
            <section className="projects-section py-5 bg-light">
                <Container>
                    <h2 className="text-center mb-5">Nos Réalisations</h2>
                    <Row>
                        {projects.map((project, index) => (
                            <Col lg={4} md={6} className="mb-4" key={index}>
                                <Card className="h-100 project-card">
                                    <div className="project-image">
                                        <img src={project.image} alt={project.title} />
                                    </div>
                                    <CardBody>
                                        <CardTitle tag="h4">{project.title}</CardTitle>
                                        <CardText>{project.description}</CardText>
                                        {/* <div className="tech-stack mb-3">
                                            {project.technologies.map((tech, idx) => (
                                                <span key={idx} className="tech-badge">
                                                    {tech}
                                                </span>
                                            ))}
                                        </div> */}
                                        <Button 
                                            href={project.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="project-btn"
                                        >
                                            Voir le projet <i className="bi bi-arrow-right ms-2"></i>
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
            <WhatsAppButton phoneNumber={phoneNumber} />

        </>
    );
};

export default Home;